import { useEffect, useState } from "react";
import { BaseURL } from "../../config/axios";
import { getOneBlog } from "../../api-route/blog";
import { Link, useLocation, useParams } from "react-router-dom";
import { BreadcrumbItem, Breadcrumbs } from "@nextui-org/react";
import { Helmet } from "react-helmet";
import React from "react";
import FaqSection from '../../Components/faq-section/index.section'

const Hr = () => (
    <hr
        className="h-[3px] max-w-[40%] mx-auto opacity-35 my-2"
        style={{
            background:
                "linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.65) 50%, rgba(0, 0, 0, 0) 90%, rgba(0, 0, 0, 0) 100%)",
        }}
    />
);

export default function Page() {
    const { slug } = useParams()
    const location = useLocation();
    const canonicalUrl = `${window.location.origin}${location.pathname}`;
    const [blog, setBlog] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const get = async () => {
            if (!slug) return; // Ensure `slug` is defined
            try {
                const data = await getOneBlog(slug);
                if (data) {
                    setBlog(data)
                } else {
                    setError("مجله هنری پیدا نشد");
                }
            } catch (err) {
                setError("مشکل در بارگزاری اطلاعات");
            } finally {
                setLoading(false);
            }
        }
        get()
    }, [slug])

    if (loading) {
        return <div className="centerOfParent h-screen w-full">درحال‌بارگذاری</div>;
    }

    if (error) {
        return <div className="centerOfParent h-screen w-full">{error}</div>;
    }

    if (!blog) {
        return <div className="centerOfParent h-screen w-full">اطلاعاتی از این مجله هنری در دسترس نیست</div>;
    }

    const generalSchema = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "x"
        },
        "headline": blog?.title,
        "description": blog?.body?.replace(/<\/?[^>]+(>|$)/g, ""),
        "image": blog.images[0] && BaseURL + blog.images[0].path,
        "author": {
            "@type": "Person",
            "name": "tonaliteh.com",
            "url": "https://www.tonaliteh.com/"
        },
        "publisher": {
            "@type": "Organization",
            "name": "tonaliteh",
            "logo": {
                "@type": "ImageObject",
                "url": "https://www.tonaliteh.com/"
            }
        },
        "datePublished": new Date(blog?.created_at).toDateString('fa-IR'),
        "dateModified": new Date(blog?.updated_at).toDateString('fa-IR')
    }

    return (
        <>
            <Helmet>
                <title>{blog?.seo_title || blog?.title}</title>
                <meta name="description" content={blog?.meta_description || blog?.body?.replace(/<\/?[^>]+(>|$)/g, "").slice(0, 600)} />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">
                    {JSON.stringify(generalSchema)}
                </script>
            </Helmet>
            <div className="container">
                {loading ? <div className="centerOfParent h-screen w-full text-xl">درحال‌بارگذاری</div> : (!!blog) &&
                    <div className="">
                        <article className="mb-5 md:mb-0 bg-[#eee] sm:p-5 p-1">
                            <div className="pb-8 pt-2 flex smflex-row flex-col-reverse gap-4 items-center sm:justify-between">
                                <div className="">
                                    تاریخ بازنشر: <b>{new Date(blog.created_at).toLocaleDateString('fa-IR')}</b>
                                </div>
                                <Breadcrumbs separator='/' itemClasses={{ separator: "px-2" }} dir="rtl">
                                    <BreadcrumbItem href="/">صفحه اصلی</BreadcrumbItem>
                                    <BreadcrumbItem href='/blogs?page=1'>مجله هنری</BreadcrumbItem>
                                    <BreadcrumbItem>{blog.title}</BreadcrumbItem>
                                </Breadcrumbs>
                            </div>
                            <div className="relative">
                                <div className="centerOfParent rounded-md overflow-hidden max-h-full h-fit shrink-0 max-w-[90%] border border-gray-300 mx-auto">
                                    <img width={100} height={100}
                                        src={blog.images[0] && BaseURL + blog.images[0].path}
                                        className="w-full h-full object-contain" alt={blog.title}
                                    />
                                </div>
                                <h4 className="absolute -bottom-5 bg-white left-1/2 -translate-x-1/2 px-2 py-1 rounded-lg text-primary text-center lg:text-3xl text-xl font-bold">{blog.title}</h4>
                            </div>

                            <div className="bg-[#0000000a] sm:w-[90%] sm:p-4 p-1 mx-auto mt-4">
                                <div className="my-4" dir="rtl">
                                    <div className={`text-justify ql-editor`} dangerouslySetInnerHTML={{ __html: blog.body_before_table }} />
                                    <div className={`text-justify ql-editor`} dangerouslySetInnerHTML={{ __html: blog.table_of_contents }} />
                                    <div className={`text-justify ql-editor`} dangerouslySetInnerHTML={{ __html: blog.body }} />
                                    <div className="overflow-hidden" dir="rtl">
                                        <div className="flex items-stretch gap-6 overflow-x-auto overflow-y-hidden p-2 pb-3 rtl:flex-row-reverse scroll-snap-x-mandatory">
                                            {blog.products.map((s) => (
                                                <div
                                                    className="bg-[#f6f6f6] flex flex-col items-center duration-300 md:hover:scale-105 overflow-hidden sm:rounded-lg min-w-[280px] w-full scroll-snap-align-start"
                                                    key={s.id}
                                                >
                                                    <div className="grow w-full border-b">
                                                        <div className="max-h-[250px] h-full overflow-hidden centerOfParent">
                                                            <img
                                                                placeholder="blur"
                                                                blurDataURL="/images/placeholder-1.png"
                                                                width={100} height={100}
                                                                src={BaseURL + s.images[0]?.path}
                                                                title={s.title}
                                                                alt={s.title || s.title_persian}
                                                                className="object-contain w-full h-full max-h-[250px]"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col items-center p-2 w-full">
                                                        <h1 className="w-full font-bold text-center line-clamp-1">
                                                            {s.title_persian}
                                                        </h1>
                                                        <div className="w-full py-2 text-center text-sm border-b">
                                                            {s.artist?.title_persian}
                                                        </div>
                                                        {!!s.year && (
                                                            <div className="w-full py-2 centerOfParent gap-1 text-xs border-b">
                                                                {s.year}
                                                            </div>
                                                        )}
                                                        <Link
                                                            to={`/product/${s.slug}`}
                                                            className="bg-primary px-4 py-2 mt-2 rounded-md text-white hover:opacity-80"
                                                        >
                                                            مشاهده
                                                        </Link>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="centerOfParent min-w-[280px] w-full bg-[#f6f6f6] rounded-lg">
                                                <Link className="border p-2 rounded bg-white" to='/product?page=1'>مشاهده بیشتر</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`text-justify ql-editor`} dangerouslySetInnerHTML={{ __html: blog.body_after_product }} />
                                    <Hr />
                                    <FaqSection faq={blog.attributes} />
                                    <Hr />
                                    <div className="flex flex-col gap-2">
                                        <h5>دیگر مقالات</h5>
                                        <div className="overflow-hidden" dir="rtl">
                                            <div className="flex items-stretch gap-6 overflow-x-auto overflow-y-hidden p-2 pb-3 rtl:flex-row-reverse scroll-snap-x-mandatory">
                                                {blog.related_blogs.map(s => (
                                                    <div className="relative h-80 overflow-hidden w-full *:transition-all *:duration-300 *:ease-in-out group bg-[#f6f6f6] flex flex-col items-center duration-300 md:hover:scale-105 sm:rounded-lg min-w-[280px] scroll-snap-align-start" key={s.id}>
                                                        <div className="grow w-full border-b">
                                                            <div className="max-h-[250px] h-full overflow-hidden centerOfParent">
                                                                <img
                                                                    className="object-contain w-full h-full max-h-[250px]"
                                                                    src={BaseURL + s.images[0]?.path} title={s.title}
                                                                    alt={s.title} placeholder='blur' blurDataURL='/images/placeholder-1.png'
                                                                    width={100} height={100}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col items-center p-2 w-full">
                                                            <h4 className="w-full  font-bold text-center line-clamp-3">
                                                                {s.title}
                                                            </h4>
                                                            <Link
                                                                to={`/blogs/${s.slug}`}
                                                                className="bg-primary px-4 py-2 mt-2 rounded-md text-white hover:opacity-80">
                                                                مشاهده
                                                            </Link>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <Hr />
                                    <div className="flex flex-col gap-2">
                                        <h5>هنرمندان</h5>
                                        <div className="overflow-hidden" dir="rtl">
                                            <div className="flex items-stretch gap-6 overflow-x-auto overflow-y-hidden p-2 pb-3 rtl:flex-row-reverse scroll-snap-x-mandatory">
                                                {blog.random_artists.map(s => (
                                                    <Link
                                                        to={"/artists/" + s.slug} key={s.id}
                                                        className="relative h-80 overflow-hidden w-full *:transition-all *:duration-300 *:ease-in-out group bg-[#f6f6f6] flex flex-col items-center duration-300 md:hover:scale-105 sm:rounded-lg min-w-[280px] scroll-snap-align-start"
                                                    >
                                                        <div
                                                            className="absolute inset-0 bg-cover bg-center group-hover:scale-110"
                                                            style={{
                                                                backgroundImage: `url('${BaseURL + s.images[0]?.path}')`,
                                                            }}
                                                        />

                                                        <div className="absolute inset-x-0 bottom-0 group-hover:bg-opacity-75 bg-slate-800 text-white p-2 text-center">
                                                            {s.title}
                                                        </div>
                                                    </Link>
                                                ))}
                                                <div className="centerOfParent min-w-[280px] w-full bg-[#f6f6f6] rounded-lg">
                                                    <Link className="border p-2 rounded bg-white" to='/artists?page=1'>مشاهده بیشتر</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Hr />
                                    <div className="flex flex-col gap-2">
                                        <h5>دسته بندی ها</h5>
                                        <div className="overflow-hidden" dir="rtl">
                                            <div className="flex items-stretch gap-6 overflow-x-auto overflow-y-hidden p-2 pb-3 rtl:flex-row-reverse scroll-snap-x-mandatory">
                                                {blog.random_categories.map(s => (
                                                    <Link
                                                        to={"/categories/" + s.slug} key={s.id}
                                                        className="relative h-80 overflow-hidden *:transition-all *:duration-300 *:ease-in-out group bg-[#f6f6f6] flex flex-col items-center duration-300 md:hover:scale-105 sm:rounded-lg min-w-[280px] w-full scroll-snap-align-start"
                                                    >
                                                        <div className="group-hover:scale-110" ><img className="w-full h-auto object-contain" placeholder='blur' blurDataURL='/images/placeholder-1.png'
                                                            width={100} height={100} src={BaseURL + s.images?.path} alt={s.title} title={s.title} /></div>
                                                        <div className="absolute inset-x-0 bottom-0 group-hover:bg-opacity-75 bg-slate-800 text-white p-2">
                                                            {s.title}
                                                        </div>
                                                    </Link>
                                                ))}
                                                <div className="centerOfParent min-w-[280px] w-full bg-[#f6f6f6] rounded-lg">
                                                    <Link className="border p-2 rounded bg-white" to='/categories?page=1'>مشاهده بیشتر</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-4" dir="rtl">
                                <span>نویسنده:</span>
                                <strong className="mr-2">{blog.author_name}</strong>
                                {blog.author_body && <p>توضیحات: {blog.author_body}</p>}
                                <p className="mt-10">شناسه مقاله: {blog.id}</p>
                            </div>
                        </article>
                    </div>
                }
            </div>
        </>
    );
}